import { render, staticRenderFns } from "./RecipientLayout.vue?vue&type=template&id=711dbf3f"
import script from "./RecipientLayout.vue?vue&type=script&lang=js"
export * from "./RecipientLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports